module.exports = __webpack_public_path__ + "c_static/img/invite-friends_icon_province_default@2x.c59e3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/invite-friends_icon_province_default@2x.png
// module id = xCWe
// module chunks = 33